<template>
    <div id="footer" class="bg-2 ">
        <div class="next2">
        </div>
        <div class="container">
            <div class="row d-flex pt-3">
                <div
                    class="row-left col-12 col-md-6 col-lg-4 order-3 order-sm-3 order-lg-3 d-flex justify-content-between flex-row">
                    <div class="footer-info">
                        <ul class="footer-links mb-0 p-0">
                            <li v-for="(menuFooter, index) of $parent.dataIris.menuFooter.itemsMenu.children" :key="index">
                                
                                <a v-if="menuFooter.link" :href="menuFooter.link" target="new">{{menuFooter.name}}</a>
                                <router-link v-else tag="a" :to="menuFooter.route">{{menuFooter.labelMenu}}</router-link>
                            </li>

                           
                        </ul>
                    </div>
                </div>
                <div class="row-middle col-12 col-md-12 col-lg-4 order-1 order-sm-1 order-lg-2 ">
                    <div class="footer-info c-3 pt-3">
                        <p>Fabricant d'appareillages orthodontiques pour les professionnels de la
                            santé dentaire de la pédodontie à la récidive adulte.</p>
                    </div>
                </div>
                <div class="row-right col-12 col-md-6 col-lg-4 order-2 order-sm-2 order-lg-1 d-flex flex-column">
                    <div class="footer-info">
                        <h5 class="c-1">
                            <span>Laboratoire ODF Tournier</span>
                        </h5>
                        <div class="footer-tel c-1">
                            <div>
                                <a href="https://goo.gl/maps/ZLqixTuupWXuvSAn9" target="_blank">7 rue de la République,
                                    76000 ROUEN</a>
                            </div>
                        </div>
                        <div>
                            <a href="#">
                                Lundi au Vendredi 9h - 12h30 > 14h30 - 19h
                            </a>
                        </div>
                        <div class="footer-tel c-1">
                            <div>
                                <img class="d-none d-md-inline" src="@/../public/elements/lt-icone-phone-gris-claire.svg" alt="">
                                <a href="tel:0676124578">
                                    06 76 12 45 78
                                </a> / <a href="tel:0663035395">
                                    06 63 03 53 95
                                </a>
                            </div>
                        </div>
                        <div class="footer-tel c-1">
                            <img class="d-none d-md-inline" src="@/../public/elements/lt-icone-email-gris-clair.svg"
                                alt="">
                            <a href="mailto:laboratoiretournier@gmail.com">
                                laboratoiretournier@gmail.com
                            </a>
                        </div>
                        <div class="footer-tel c-1">
                            <a href="https://www.facebook.com/laboratoiretournier3d/"><img
                                    src="@/../public/elements/lt-icone-facebook-gris-clair.svg" alt=""></a>
                            <a class="d-none d-md-inline"
                                href="https://www.facebook.com/laboratoiretournier3d/">Laboratoire Tournier 3D</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-12 copyright">
                    <div class="d-flex justify-content-between">
                        <p>Copyright © 2020 <a href="https://www.laboratoire-tournier.fr/">LABORATOIRE TOURNIER</a>
                            - Tous droits réservés. Réalisation : <a href="https://www.devinfluence.fr" class="white-link">DEV'INFLUENCE</a>
                        </p>
                        <p>
                            <a href="mentions-legales" class="white-link">Mentions Légales</a> | <a href="contact" class="white-link">Contact</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

export default {
    name: "esp-header",
    props: {
        dataPage:{
            type: Object
        }
    },
    data() {
        return {
          
        }
    },
    computed:{
        customizableVar1: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return this.dataPage.customizableVar[0].value.value
            }else{
                return "0f555d"
            }
        }
    },
    methods: {
        formatLabelMenu(str) {
            return str.replace("<br>"," ")
            
        },
        getSrcMenuPage(idPage) {
            let page = this.$parent.dataIris.pages.find(page => page.id === idPage) 
            
            return "" //require('@/html/elements/o-'+page.customizableVar[0].value.value+'.svg')
        }
    }
}
</script>

